import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../interfaces/base";
import {
  ICreateVodAction,
  IDeleteVodAction,
  IGetVodAction,
  IUpdateVodAction,
} from "../../../interfaces/store/vod-interface";
import {
  getVodFailed,
  getVodSuccess,
  getVodStart,
  createVodStart,
  createVodSuccess,
  createVodFailed,
  updateVodStart,
  updateVodSuccess,
  updateVodFailed,
  deleteVodStart,
  deleteVodFailed,
  deleteVodSuccess,
} from "./vod-slice";
import { deleteVodApi, getVodApi, updateVodApi } from "../../../api/vod";
import { createVodApi } from "../../../api/vod";
import { IUploadFileParams } from "../../../interfaces/files/files";
import { uploadImage } from "../../utils/fileUpload";
import { base64ToBlob } from "../../../utils/utils";

function* _getVod({ payload }: IGetVodAction) {
  try {
    const { vodId } = payload;

    if (!vodId) {
      yield put(getVodFailed({ message: "Vod ID is required" }));
      return;
    }

    const vod: IBaseResponse = yield call(getVodApi, vodId);

    if (vod.error) {
      yield put(getVodFailed(vod.error));
    }

    yield put(getVodSuccess(vod.data));
  } catch (error: any) {
    yield put(getVodFailed({ message: error.message }));
  }
}

function* _createVod({ payload }: ICreateVodAction) {
  try {
    const response: IBaseResponse = yield call(createVodApi, payload);

    const { imageData, videoData } = payload;

    const blobImageData = imageData
      ? {
          ...imageData,
          binaryFile: base64ToBlob(imageData.binaryFile as string),
        }
      : undefined;

    const blobVideoData = videoData
      ? {
          ...videoData,
          binaryFile: base64ToBlob(videoData.binaryFile as string),
        }
      : undefined;

    if (blobImageData)
      yield call(handleMediaData, blobImageData, response.data._id, "image");
    if (blobVideoData)
      yield call(handleMediaData, blobVideoData, response.data._id, "video");

    if (response.error) {
      yield put(createVodFailed(response.error));
    } else {
      yield put(createVodSuccess(response.data));
    }
  } catch (error: any) {
    console.log("error:", error);
    yield put(createVodFailed({ message: error.message }));
  }
}

function* _updateVod({ payload }: IUpdateVodAction) {
  try {
    const { vodId, vod, imageData, videoData } = payload;

    const blobImageData = imageData
      ? {
          ...imageData,
          binaryFile: base64ToBlob(imageData.binaryFile as string),
        }
      : undefined;

    const blobVideoData = videoData
      ? {
          ...videoData,
          binaryFile: base64ToBlob(videoData.binaryFile as string),
        }
      : undefined;

    if (blobImageData && blobImageData.binaryFile) {
      yield call(uploadImage, blobImageData, vodId);
    }
    if (blobVideoData && blobVideoData.binaryFile) {
      yield call(uploadImage, blobVideoData, vodId);
    }

    const updateBody = vod;

    if (updateBody) {
      if (blobImageData?.fileName) {
        updateBody.image = vodId + "/" + blobImageData.fileName;
      } else if (blobImageData && blobImageData.binaryFile === null) {
        updateBody.image = null;
      }

      if (blobVideoData?.fileName) {
        updateBody.video = vodId + "/" + blobVideoData.fileName;
      } else if (blobVideoData && blobVideoData.binaryFile === null) {
        updateBody.video = null;
      }
    }

    const response: IBaseResponse = yield call(updateVodApi, {
      vodId,
      vod,
    });

    if (response.error) {
      yield put(updateVodFailed(response.error));
    } else {
      yield put(updateVodSuccess(response.data));
    }
  } catch (error: any) {
    console.log("error:", error);
    yield put(updateVodFailed({ message: error.message }));
  }
}

function* _deleteVod({ payload }: IDeleteVodAction) {
  try {
    const response: IBaseResponse = yield call(deleteVodApi, payload.vodId);

    if (response.error) {
      yield put(deleteVodFailed(response.error));
    } else {
      yield put(deleteVodSuccess(response.data));
    }
  } catch (error: any) {
    console.log("error:", error);
    yield put(deleteVodFailed({ message: error.message }));
  }
}

function* handleMediaData(
  mediaData: IUploadFileParams,
  responseId: string,
  mediaType: "image" | "video"
) {
  if (mediaData && responseId) {
    if (mediaData.binaryFile) {
      yield call(uploadImage, mediaData, responseId);
    }
    yield call(_updateVod, {
      payload: {
        vod: {
          [mediaType]: mediaData.binaryFile
            ? responseId + "/" + mediaData.fileName
            : null,
        },
        vodId: responseId,
      },
      type: updateVodStart.type,
    });
  }
}

function* vodSaga() {
  yield takeLatest(getVodStart.type, _getVod);
  yield takeLatest(createVodStart.type, _createVod);
  yield takeLatest(updateVodStart.type, _updateVod);
  yield takeLatest(deleteVodStart.type, _deleteVod);
}

export default vodSaga;
